import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import HealthPlanMedicalReport from './HealthPlanMedicalReport';

interface HealthPlanMedicalReportModalProps {
	patientId: string;
	workplaceId: string;
	opened: boolean;
	onClose: any;
	disableSubmit?: boolean;
}

export default function HealthPlanMedicalReportModal(
	props: HealthPlanMedicalReportModalProps,
) {
	const { opened, onClose, patientId, workplaceId, disableSubmit } = props;
	const { isCase } = useTreatmentContext();

	return (
		<>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={'base.shared.medicalExamination'} />
				<Modal.Content contentScroll={true}>
					<HealthPlanMedicalReport
						patientId={patientId}
						workplaceId={workplaceId}
						onSuccess={onClose}
						disableSubmit={disableSubmit}
					/>
				</Modal.Content>
			</Modal>
		</>
	);
}
